module.exports = __webpack_public_path__ + "static/media/DSC03572.47d7dc12.JPG";